import { ContestantUsers } from "API/Generated/ContestantUsers";
import { ContestantUsersBasic } from "API/Generated/ContestantUsersBasic";
import { ContestantDuplicateGroupWithRegistrationsDto, ContestantDuplicateGroupWithRegistrationsDtoIReadOnlyListResponseWrapper, ContestantProfileDto, ContestantPublicInfoBaseModel,  ContestantUserBaseModel, ContestantWinningBasicDto,  PictureModel, RegisteredContestantPublicInfo } from "API/Generated/data-contracts";
import { ContestantUserModel } from "API/Generated/data-contracts";
import { RequestStatus } from "SessionState/RequestHandling/RequestStatus";
import { makeObservable, observable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

interface Request {
    id: number;
    status: RequestStatus;
    firstName: string | null | undefined;
    lastName: string | null | undefined;
    birthday: string | null | undefined;
}

    type DuplicateScanOptions = {
  minSimilarity?: number;
  maxGroups?: number;
  maxCandidatesPerGroup?: number;
  exactOnly?: boolean;
};

type MergeDuplicateContestantsRequest = {
  keepContestantUserId: number;
  mergeContestantUserIds: number[];
};

class ContestantStore {
    ContestantService: ContestantUsers = new ContestantUsers();
    ContestantServiceBasic: ContestantUsersBasic = new ContestantUsersBasic();
    CurrentContestant: ContestantUserModel;
    ContestantListBasic: ContestantUserBaseModel[] = [];
    ContestantListPublicInfo: ContestantPublicInfoBaseModel[] = [];
    RecentTitleWinners: RegisteredContestantPublicInfo[] = [];
    ContestantList: ContestantUserModel[];
    CurrentContestantRequest: Request = {
        id: 0,
        status: RequestStatus.PENDING,
        firstName: "",
        lastName: "",
        birthday: "",
    };
    CurrentContestantPublicRequest: Request = {
        id: 0,
        status: RequestStatus.PENDING,
        firstName: "",
        lastName: "",
        birthday: "",
    };
DuplicateScanResults: ContestantDuplicateGroupWithRegistrationsDto[] = [];
DuplicateScanStatus: RequestStatus = RequestStatus.PENDING;
DuplicateScanError: string | null = null;
MergeDuplicatesStatus: RequestStatus = RequestStatus.PENDING;
MergeDuplicatesError: string | null = null;

ContestantWinnings: ContestantWinningBasicDto[] = [];
ContestantWinningsStatus: RequestStatus = RequestStatus.PENDING;
ContestantWinningsError: string | null = null;
CurrentContestantWinningsRequest: { contestantUserId: number; status: RequestStatus } = {
  contestantUserId: 0,
  status: RequestStatus.PENDING,
};

ContestantPublicProfileDetails: ContestantPublicInfoBaseModel | null = null;
ContestantPublicProfileDetailsStatus: RequestStatus = RequestStatus.PENDING;
ContestantPublicProfileDetailsError: string | null = null;
CurrentContestantPublicProfileDetailsRequest: { contestantUserId: number; status: RequestStatus } = {
  contestantUserId: 0,
  status: RequestStatus.PENDING,
};

  ContestantPrivateProfileDetails: ContestantProfileDto  | null = null;
  ContestantPrivateProfileDetailsStatus: RequestStatus = RequestStatus.PENDING;
  ContestantPrivateProfileDetailsError: string | null = null;

  CurrentContestantPrivateProfileDetailsRequest: { contestantUserId: number; status: RequestStatus } = {
    contestantUserId: 0,
    status: RequestStatus.PENDING,
  };

ContestantPublicProfileDetailsList: ContestantProfileDto [] = [];
ContestantPublicProfileDetailsListStatus: RequestStatus = RequestStatus.PENDING;
ContestantPublicProfileDetailsListError: string | null = null;

CurrentContestantPublicProfileDetailsListRequest: { key: string; status: RequestStatus } = {
  key: "",
  status: RequestStatus.PENDING,
};




    constructor(currentContestant: ContestantUserModel, contestantList: ContestantUserModel[], contestantListBasic: ContestantUserBaseModel[], contestantListPublicInfo: ContestantPublicInfoBaseModel[], contestantPublicProfileDetailsList: ContestantProfileDto[], currentContestantRequest: Request, currentContestantPublicRequest: Request ) {
        makeObservable(this, {
            CurrentContestant: observable,
            ContestantList: observable,
            ContestantListBasic: observable,
            ContestantListPublicInfo: observable,
            CurrentContestantRequest: observable,
            CurrentContestantPublicRequest: observable,
              DuplicateScanResults: observable,
  DuplicateScanStatus: observable,
  DuplicateScanError: observable,
  MergeDuplicatesStatus: observable,
MergeDuplicatesError: observable,
ContestantWinnings: observable,
ContestantWinningsStatus: observable,
ContestantWinningsError: observable,
CurrentContestantWinningsRequest: observable,
ContestantPublicProfileDetails: observable,
ContestantPublicProfileDetailsStatus: observable,
ContestantPublicProfileDetailsError: observable,
CurrentContestantPublicProfileDetailsRequest: observable,

ContestantPrivateProfileDetails: observable,
ContestantPrivateProfileDetailsStatus: observable,
ContestantPrivateProfileDetailsError: observable,
CurrentContestantPrivateProfileDetailsRequest: observable,

ContestantPublicProfileDetailsList: observable,
ContestantPublicProfileDetailsListStatus: observable,
ContestantPublicProfileDetailsListError: observable,
CurrentContestantPublicProfileDetailsListRequest: observable,


        })
        // makePersistable(this, {name: 'ContestantStore', properties: ['CurrentContestant', 'ContestantList', 'CurrentContestantRequest']});
        this.CurrentContestant = currentContestant;
        this.ContestantList = contestantList;
        this.ContestantListBasic = contestantListBasic;
        this.ContestantListPublicInfo = contestantListPublicInfo;
        this.CurrentContestantRequest = currentContestantRequest;
        this.CurrentContestantPublicRequest = currentContestantPublicRequest;


        this.ContestantPublicProfileDetailsList = contestantPublicProfileDetailsList;

    }

    async saveContestant(model: ContestantUserModel): Promise<boolean>{
        try {
            if ((this.CurrentContestantRequest.id == model.id || (this.CurrentContestantRequest.firstName == model.firstName && this.CurrentContestantRequest.lastName == model.lastName && this.CurrentContestantRequest.birthday == model.birthday)) 
            && (this.CurrentContestantRequest.status == RequestStatus.ACTIVE || this.CurrentContestantRequest.status == RequestStatus.COMPLETED)
                ) {
                return false;
                };
            this.resetCurrentContestant()
            this.CurrentContestantRequest = { id: model.id ?? 0, status: RequestStatus.ACTIVE, firstName: model.firstName, lastName: model.lastName, birthday: model.birthday };
            var contestantResult = await this.ContestantService.saveContestantUser(model);
            if (contestantResult.data.data) {
                this.CurrentContestantRequest.status = RequestStatus.COMPLETED;
                this.CurrentContestant = contestantResult?.data.data;    
                return true;
            }
            return false;
        } catch (error){
            this.CurrentContestantRequest.status = RequestStatus.ERROR;
            console.log("Error: " + JSON.stringify(error));
            return false;
        }
    }
    
    // async getContestant(id: number, reset:boolean = false) {
    //     try {
    //         if (this.CurrentContestantRequest.id == id && 
    //             (this.CurrentContestantRequest.status == RequestStatus.ACTIVE || this.CurrentContestantRequest.status == RequestStatus.COMPLETED)
    //             && !reset) {
    //             return;
    //         }
    //         this.resetCurrentContestant()
    //         this.CurrentContestantRequest = { id: id, status: RequestStatus.ACTIVE, firstName: this.CurrentContestant.firstName, lastName: this.CurrentContestant.lastName, birthday: this.CurrentContestant.birthday };
    //         var contestantResult = await this.ContestantService.getByContestantUserId(id)
    //         console.log("data", contestantResult);
    //         if (contestantResult.data) {
    //             this.CurrentContestantRequest.status = RequestStatus.COMPLETED;
    //             this.CurrentContestant = contestantResult?.data;
    //         }
    //     } catch (error) {
    //         this.CurrentContestantRequest.status = RequestStatus.ERROR;
    //         console.log("Error:" + JSON.stringify(error));
    //     }
    // }

    async getContestant(id: number, reset: boolean = false): Promise<ContestantUserModel | undefined> {
        try {
            if (this.CurrentContestantRequest.id === id && 
                (this.CurrentContestantRequest.status === RequestStatus.ACTIVE || this.CurrentContestantRequest.status === RequestStatus.COMPLETED)
                && !reset) {
                return this.CurrentContestant; // Return the current contestant if already fetched
            }
            this.resetCurrentContestant();
            this.CurrentContestantRequest = { id: id, status: RequestStatus.ACTIVE, firstName: this.CurrentContestant.firstName, lastName: this.CurrentContestant.lastName, birthday: this.CurrentContestant.birthday };
            var contestantResult = await this.ContestantService.getByContestantUserId(id);
            console.log("API response:", contestantResult); // Log the API response
            if (contestantResult.data) {
                this.CurrentContestantRequest.status = RequestStatus.COMPLETED;
                this.CurrentContestant = contestantResult.data;
                return this.CurrentContestant; // Return the fetched contestant
            }
        } catch (error) {
            this.CurrentContestantRequest.status = RequestStatus.ERROR;
            console.log("Error:" + JSON.stringify(error));
        }
        return undefined; // Return undefined in case of error
    }

    async getContestants() {
        try {
            var contestantResult = await this.ContestantService.getAllContestantUsers();
            this.ContestantList = contestantResult?.data;
        }
        catch (error) {
            console.log("Errror: " + JSON.stringify(error))
        }
    }

    async getContestantsPublicInfo(reset = false) {

        if (this.CurrentContestantPublicRequest.status === RequestStatus.ACTIVE ||
            this.CurrentContestantPublicRequest.status === RequestStatus.COMPLETED && !reset) {
          return;
        }
    
        this.CurrentContestantPublicRequest.status = RequestStatus.ACTIVE;
    
        try {
          const contestantResult = await this.ContestantServiceBasic.getAllContestantUsersBasicPublicInfo();
    
          if (contestantResult?.data) {
            runInAction(() => {
              this.ContestantListPublicInfo = contestantResult.data
                .filter(contestant => contestant.userId != null && !contestant.accountPrivate)
                .map(contestant => ({
                  id: contestant.id ?? 0,
                  firstName: contestant.firstName ?? "",
                  lastName: contestant.lastName ?? "",
                  hairColor: contestant.hairColor ?? "",
                  eyeColor: contestant.eyeColor ?? "",
                  profilePic: contestant.profilePic ? {
                    id: contestant.profilePic.id ?? 0,
                    image: contestant.profilePic.image ?? "",
                    imageName: contestant.profilePic.imageName ?? "",
                    imageType: contestant.profilePic.imageType ?? ""
                  } : undefined,
                  userId: contestant.userId ?? 0,
                  city: contestant.city ?? "",
                  stateId: contestant.stateId ?? 0,
                  accountPrivate: contestant.accountPrivate ?? false,
                  titleCount: contestant.titleCount ?? 0,
                }));
    
              this.CurrentContestantPublicRequest.status = RequestStatus.COMPLETED;
            //   this.ContestantListBasic = contestantResult?.data;
            });
          }
        } catch (error) {
          runInAction(() => {
            this.CurrentContestantPublicRequest.status = RequestStatus.ERROR;
          });
          console.log("Error fetching contestants' public info: " + JSON.stringify(error));
        }
      }

    async getContestantPublicInfo(id: number, reset:boolean = false) {
        try {
            if (this.CurrentContestantPublicRequest.id == id && 
                (this.CurrentContestantPublicRequest.status == RequestStatus.ACTIVE || this.CurrentContestantPublicRequest.status == RequestStatus.COMPLETED)
                && !reset) {
                return;
            }
            this.resetCurrentContestant()
            this.CurrentContestantPublicRequest = { id: id, status: RequestStatus.ACTIVE, firstName: this.CurrentContestant.firstName, lastName: this.CurrentContestant.lastName, birthday: this.CurrentContestant.birthday };
            var contestantResult = await this.ContestantServiceBasic.getContestantUserPublicInfoByContestantId(id)
            console.log("data", contestantResult);
            if (contestantResult.data) {
                this.CurrentContestantPublicRequest.status = RequestStatus.COMPLETED;
                this.CurrentContestant = contestantResult?.data;
            }
        } catch (error) {
            this.CurrentContestantPublicRequest.status = RequestStatus.ERROR;
            console.log("Error:" + JSON.stringify(error));
        }
    }

    //====Get contestant public profile details - testing

async getContestantPublicProfilesWithWinnings(
  contestantUserIds?: number[] | null,
  reset: boolean = false
): Promise<void> {
  try {
    if (
      this.ContestantPublicProfileDetailsListStatus === RequestStatus.ACTIVE ||
      (this.ContestantPublicProfileDetailsListStatus === RequestStatus.COMPLETED && !reset)
    ) {
      return;
    }

    runInAction(() => {
      this.ContestantPublicProfileDetailsListStatus = RequestStatus.ACTIVE;
      this.ContestantPublicProfileDetailsListError = null;
      if (reset) this.ContestantPublicProfileDetailsList = [];
    });

    const resp = await this.ContestantService.contestantPublicProfilesFetchDynamic({
      contestantUserIds: contestantUserIds?.length ? contestantUserIds : null,
    });

    const list = (resp?.data ?? []) as ContestantProfileDto[];

    runInAction(() => {
      this.ContestantPublicProfileDetailsList = list;
      this.ContestantPublicProfileDetailsListStatus = RequestStatus.COMPLETED;

      this.ContestantListPublicInfo = list
        .map((x: ContestantProfileDto) => x.profileDetails)
        .filter(Boolean) as any;
    });
  } catch (error: any) {
    runInAction(() => {
      this.ContestantPublicProfileDetailsList = [];
      this.ContestantPublicProfileDetailsListStatus = RequestStatus.ERROR;
      this.ContestantPublicProfileDetailsListError =
        error?.message ?? "Failed to load public profiles";
    });

    console.log("Error fetching public profiles:", error);
  }
}

async getContestantPrivateProfile(
  contestantUserId: number,
  reset: boolean = false
): Promise<void> {
  try {
    if (!contestantUserId) return;

    runInAction(() => {
      this.ContestantPrivateProfileDetailsStatus = RequestStatus.ACTIVE;
      this.ContestantPrivateProfileDetailsError = null;

      this.CurrentContestantPrivateProfileDetailsRequest = {
        contestantUserId,
        status: RequestStatus.ACTIVE,
      };

      if (reset) this.ContestantPrivateProfileDetails = null;
    });

    const resp = await this.ContestantService.contestantPrivateProfile(contestantUserId);

    const body: any = resp?.data;

    const dto: ContestantProfileDto | null =
      body?.data ? body.data :
      body?.profileDetails ? body :
      null;

    runInAction(() => {
      this.ContestantPrivateProfileDetails = dto;

      if (dto?.profileDetails) {
        this.CurrentContestant = {
          ...this.CurrentContestant,
          ...dto.profileDetails,
        } as any;
      }

      this.ContestantPrivateProfileDetailsStatus = RequestStatus.COMPLETED;
      this.CurrentContestantPrivateProfileDetailsRequest.status = RequestStatus.COMPLETED;
    });
  } catch (error: any) {
    runInAction(() => {
      this.ContestantPrivateProfileDetails = null;
      this.ContestantPrivateProfileDetailsStatus = RequestStatus.ERROR;
      this.ContestantPrivateProfileDetailsError =
        error?.message ?? "Failed to load private profile";

      this.CurrentContestantPrivateProfileDetailsRequest = {
        contestantUserId,
        status: RequestStatus.ERROR,
      };
    });

    console.log("Error fetching private contestant profile:", error);
  }
}




async deleteContestantUser(contestantUserId: number): Promise<boolean> {
  try {
    const resp = await this.ContestantService.deleteContestantUser({ contestantUserId });

    // Most of your endpoints return ResponseWrapper<T>
    const body: any = resp?.data;

    if (body?.isSuccessful) return true;

    console.log("Delete contestant failed:", body?.exception);
    return false;
  } catch (error) {
    console.log("Error deleting contestant:", error);
    return false;
  }
}

//===============Get Contestant's Winnings - start============
async getContestantWinnings(
  contestantUserId: number,
  reset: boolean = false
): Promise<ContestantWinningBasicDto[] | undefined> {
  try {
    if (
      !reset &&
      this.CurrentContestantWinningsRequest.contestantUserId === contestantUserId &&
      (
        this.ContestantWinningsStatus === RequestStatus.ACTIVE ||
        this.ContestantWinningsStatus === RequestStatus.COMPLETED
      )
    ) {
      return this.ContestantWinnings;
    }

    runInAction(() => {
      this.ContestantWinningsStatus = RequestStatus.ACTIVE;
      this.ContestantWinningsError = null;
      this.CurrentContestantWinningsRequest = {
        contestantUserId,
        status: RequestStatus.ACTIVE,
      };

      if (reset) this.ContestantWinnings = [];
    });

    const resp = await this.ContestantService.contestantPrivateWinningsSearch({
      contestantUserIds: [contestantUserId],
      pageantIds: null,
    });

    const winnings = (resp?.data ?? []) as ContestantWinningBasicDto[];

    runInAction(() => {
      this.ContestantWinnings = winnings;
      this.ContestantWinningsStatus = RequestStatus.COMPLETED;
      this.CurrentContestantWinningsRequest.status = RequestStatus.COMPLETED;
    });

    return winnings;
  } catch (error: any) {
    runInAction(() => {
      this.ContestantWinnings = [];
      this.ContestantWinningsStatus = RequestStatus.ERROR;
      this.CurrentContestantWinningsRequest.status = RequestStatus.ERROR;
      this.ContestantWinningsError = error?.message ?? "Failed to load winnings";
    });

    console.log("Error fetching contestant winnings:", error);
    return undefined;
  }
}
async refreshContestantWinnings(): Promise<void> {
  const id = this.CurrentContestant?.id ?? 0;
  if (!id) return;
  await this.getContestantWinnings(id, true);
}

//===============Get Contestant's Winnings - end============

//===============Handle duplicated contestants, and merging and cleaning up registration, etc - start============


async scanDuplicateContestants(options?: DuplicateScanOptions): Promise<boolean> {
  try {
    runInAction(() => {
      this.DuplicateScanStatus = RequestStatus.ACTIVE;
      this.DuplicateScanError = null;
    });

    // IMPORTANT: use the exact generated method name here:
    const resp = await this.ContestantService.getPotentialDuplicateContestantUsersWithRegistrations({
      minSimilarity: options?.minSimilarity ?? 0.92,
      maxGroups: options?.maxGroups ?? 200,
      maxCandidatesPerGroup: options?.maxCandidatesPerGroup ?? 100,
      exactOnly: options?.exactOnly ?? false,
    });

    const body = resp.data as ContestantDuplicateGroupWithRegistrationsDtoIReadOnlyListResponseWrapper;

    if (!body?.isSuccessful) {
      runInAction(() => {
        this.DuplicateScanResults = [];
        this.DuplicateScanStatus = RequestStatus.ERROR;
        this.DuplicateScanError = (body?.exception as any)?.toString?.() ?? "Scan failed";
      });
      return false;
    }

    // Normalize: drop any weird nulls, ensure primary exists
    const groups = (body.data ?? [])
      .filter((g): g is ContestantDuplicateGroupWithRegistrationsDto => !!g && !!g.primary);

    runInAction(() => {
      this.DuplicateScanResults = groups;
      this.DuplicateScanStatus = RequestStatus.COMPLETED;
      this.DuplicateScanError = null;
    });

    return true;
  } catch (error: any) {
    runInAction(() => {
      this.DuplicateScanResults = [];
      this.DuplicateScanStatus = RequestStatus.ERROR;
      this.DuplicateScanError = error?.message ?? "Request failed";
    });
    console.log("Error scanning duplicates:", error);
    return false;
  }
}

async mergeDuplicateContestants(req: MergeDuplicateContestantsRequest): Promise<boolean> {
  try {
    runInAction(() => {
      this.MergeDuplicatesStatus = RequestStatus.ACTIVE;
      this.MergeDuplicatesError = null;
    });

    // ✅ CHANGE THIS to your generated method name from Swagger
    // Example patterns:
    // - this.ContestantService.mergeDuplicateContestants(req)
    // - this.ContestantService.mergeContestantDuplicates(req)
    // - this.ContestantService.postContestantUsersMergeDuplicates(req)
    const resp = await (this.ContestantService as any).mergeDuplicateContestants(req);

    const body: any = resp?.data;

    if (!body?.isSuccessful) {
      runInAction(() => {
        this.MergeDuplicatesStatus = RequestStatus.ERROR;
        this.MergeDuplicatesError = body?.exception?.toString?.() ?? "Merge failed";
      });
      return false;
    }

    runInAction(() => {
      this.MergeDuplicatesStatus = RequestStatus.COMPLETED;
      this.MergeDuplicatesError = null;
    });

    return true;
  } catch (error: any) {
    runInAction(() => {
      this.MergeDuplicatesStatus = RequestStatus.ERROR;
      this.MergeDuplicatesError = error?.message ?? "Merge request failed";
    });
    return false;
  }
}

async movePageantRegistration(registrationId: number, toContestantUserId: number): Promise<boolean> {
  try {
    const resp = await (this.ContestantService as any).moveRegistration({
      registrationId,
      toContestantUserId,
    });

    return !!resp?.data; // or resp.data.isSuccessful depending on your wrapper
  } catch (e) {
    console.error('movePageantRegistration failed', e);
    return false;
  }
}

//===============Handle duplicated contestants, and merging and cleaning up registration, etc - end============

    async getRecentTitleWinners() {
        try {
          const recentWinnersResult = await this.ContestantServiceBasic.getAllRecentWinnersBasicPublicInfo();
          if (recentWinnersResult?.data) {
            this.RecentTitleWinners = recentWinnersResult.data
              .filter(contestant => contestant.userId != null && !contestant.accountPrivate)
              .flatMap(contestant =>
                contestant.registeredContestants
                  ?.filter(rc => rc.wonTitles && rc.wonTitles.length > 0)
                  .map(rc => ({
                    registrationId: rc.registrationId,
                    ageGroupId: rc.pageantAgeGroup?.id,
                    headShot: rc.headShot ? {
                      id: rc.headShot.id ?? 0,
                      image: rc.headShot.image ?? "",
                      imageName: rc.headShot.imageName ?? "",
                      imageType: rc.headShot.imageType ?? ""
                    } : undefined,
                    wonTitles: rc.wonTitles ?? [],
                    pageant: rc.pageant
                  }))
                  .filter(Boolean) as RegisteredContestantPublicInfo[]
              );
          }
        } catch (error) {
          console.log("Error fetching recent title winners: " + JSON.stringify(error));
        }
      }


    async refreshCurrentContestant() {
        try {
          
            var contestantResult = await this.ContestantService.getByContestantUserId(this.CurrentContestantRequest.id);
            runInAction(() => {
                console.log("Refreshing Contestant: ", contestantResult);
                this.CurrentContestant = contestantResult?.data || {};
            });
        }
        catch (error) {
            // TODO: Call Log API endpoint
            console.log("Error: " + JSON.stringify(error));
        }
        // if (this.CurrentContestant.id !== undefined && this.CurrentContestant.id !== null) {
        //    await this.getContestant(this.CurrentContestant.id);
           
        // }
    }


    async resetCurrentContestant() {
        this.CurrentContestant = {};
    }
    async saveImage(image: PictureModel): Promise<boolean> {
        try {
            console.log("BeforeRequest");
            
            let currentContestant = this.CurrentContestant;
            console.log("SetImage");
            currentContestant.profilePic = {...image};
            console.log("Attempt Request");
            let apiResult = await this.ContestantService.saveContestantUser(currentContestant);
            if (apiResult.data) {
                console.log("requestResponse", apiResult.data);
                if (apiResult.data.isSuccessful) {
                    return true;
                }
                // return apiResult.data.exception!!;
                return false;
            }
            return false;
        }
        catch (error) {
            console.log("Error in Store");
            console.log(`Error: ${JSON.stringify(error)}`);
            return false;
        }
    }

    async saveContestantSettings(contestant: ContestantUserBaseModel): Promise<boolean> {
        try {
            console.log("BeforeRequest");
            
            let currentContestant = {...this.CurrentContestant};
            currentContestant.firstName = contestant.firstName;
            currentContestant.lastName = contestant.lastName;
            currentContestant.hairColor = contestant.hairColor;
            currentContestant.eyeColor = contestant.eyeColor;
            currentContestant.city = contestant.city;
            currentContestant.stateId = contestant.stateId;
            currentContestant.hobbies = contestant.hobbies;
            currentContestant.profilePic = contestant.profilePic;
            currentContestant.registeredPageantContestants = undefined;
            currentContestant.birthday = contestant.birthday;
            currentContestant.accountPrivate = contestant.accountPrivate;
            currentContestant.userId = contestant.userId;
            
            let apiResult = await this.ContestantService.saveContestantUser(currentContestant);
            if (apiResult.data) {
                console.log("requestResponse", apiResult.data);
                if (apiResult.data.isSuccessful) {
                    return true;
                }
                // return apiResult.data.exception!!;
                return false;
            }
            return false;
        }
        catch (error) {
            console.log("Error in Store");
            console.log(`Error: ${JSON.stringify(error)}`);
            return false;
        }
    }
}

let contestantStore: ContestantStore;

export function GetContestantStore() {
    if (!contestantStore) {
        contestantStore = new ContestantStore({}, [], [], [], [], {id: 0, status: RequestStatus.PENDING, firstName: "", lastName: "", birthday: "" }, {id: 0, status: RequestStatus.PENDING, firstName: "", lastName: "", birthday: "" });
    }
    return contestantStore;
}